import { Events, scroller } from "react-scroll";

export const smoothScrollToTarget = (target: string) =>
  new Promise((resolve) => {
    Events.scrollEvent.register("end", () => {
      resolve();
      Events.scrollEvent.remove("end");
    });
    scroller.scrollTo(target, {
      delay: 50,
      duration: 350,
      smooth: true,
      offset: -150,
    });
  });
